import { HttpClient } from '@angular/common/http';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import { BaseDataService } from './base.data.service';
import { Injectable } from '@angular/core';
import { ICommsHistorySearchItem } from '../interfaces/comms-history';
import { ICommsTemplateSearch } from '../interfaces/comms-template';

@Injectable({
  providedIn: 'root',
})
export class CommsHistoryService extends BaseDataService {
  url = '/api/commsHistory';
  entityTitle = 'Comms History';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  getCommsHistory(filter?: ICommsTemplateSearch): Promise<ICommsHistorySearchItem[]> {
    let params = this.constructHttpParams(filter);

    return this.handleRequest<ICommsHistorySearchItem[]>(
      this.http.get<ICommsHistorySearchItem[]>(this.url, { params: params }),
      this.handlersFactory.getForReadAll(),
    );
  }
}
